namespace Matrix.Rebalancer {
    export class OverlayAccountColumns {
        static columnsKey = 'Rebalancer.OverlayAccount';
    }
}
